import { Capacitor } from "@capacitor/core";

function onDeviceReady() {
  return import("./main-deviceready");
}

if (Capacitor.isNativePlatform()) {
  document.addEventListener("deviceready", onDeviceReady, false);
} else {
  window.FileNative = window.File;
  document.addEventListener("DOMContentLoaded", onDeviceReady, false);
}
